import React from "react";
import { getFullName } from "../../careprovider/visits/utils";
import { Table, Typography } from "antd";
import moment from "moment";
import { getLocalTimeZoneDateFormat } from "../../../utils/dateutils";
import FormSummaryAction from "./FormSummaryAction";
import StatusTag from "../careplan/visitlist/StatusTag";

const FormSummaryTable = ({ data = [], loading }) => {
  const columns = [
    {
      title: "Submitted On",
      key: "dateAndTime",
      sorter: {
        compare: (a, b) => a.createdTimestamp - b.createdTimestamp,
      },
      render: (_, { createdTimestamp }) =>
        moment(createdTimestamp).format(
          `${getLocalTimeZoneDateFormat()}, h:mm:ss A`
        ),
    },
    {
      title: "Service Date",
      key: "serviceDate",
      sorter: {
        compare: (a, b) => a.taskDate - b.taskDate,
      },
      render: (_, { taskDate }) =>
        moment(taskDate).format(getLocalTimeZoneDateFormat()),
    },
    {
      title: "Volunteer",
      dataIndex: "volunteer",
      sorter: (a, b) => {
        const nameA =
          getFullName(a?.workforce?.givenName, a?.workforce?.familyName) || "";
        const nameB =
          getFullName(b?.workforce?.givenName, b?.workforce?.familyName) || "";
        if (!nameA && !nameB) return 0;
        return nameA.localeCompare(nameB);
      },
      render: (_, { workforce, coordinator }) => {
        return (
          <>
            <Typography>
              {getFullName(workforce?.givenName, workforce?.familyName)}
            </Typography>
            {coordinator && (
              <Typography>
                By:{" "}
                {getFullName(coordinator?.givenName, coordinator?.familyName)}{" "}
                (VC)
              </Typography>
            )}
          </>
        );
      },
    },
    {
      title: "Patient/Recipient",
      key: "patient",
      sorter: (a, b) => {
        const nameA =
          getFullName(a?.patient?.givenName, a?.patient?.familyName) || "";
        const nameB =
          getFullName(b?.patient?.givenName, b?.patient?.familyName) || "";
        if (!nameA && !nameB) return 0;
        return nameA.localeCompare(nameB);
      },
      render: (_, { patient }) =>
        patient
          ? getFullName(patient?.givenName, patient?.familyName)
          : "Office Work",
    },
    {
      title: "Form Name",
      key: "formName",
      render: (_, { formIdentifier, status }) => {
        const formData = JSON.parse(formIdentifier || "{}");
        return (
          <>
            <Typography>{formData[0]?.formName}</Typography>
            <StatusTag
              status={status}
              label={status === "Submitted" ? "Pending Approval" : status}
              style={{ borderRadius: 4 }}
            />
          </>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      roles: ["Volunteer", "Volunteer Coordinator"],
      render: (_, formData) => <FormSummaryAction formData={formData} />,
    },
  ];

  return (
    <>
      <div className="tableContainerStyling care-plan-table">
        <div className="scroll-container" id="scrollableDiv">
          <Table
            loading={loading}
            className="tableStyling"
            columns={columns}
            dataSource={data?.map((item, index) => ({
              ...item,
              key: index,
            }))}
            pagination={false}
          />
        </div>
      </div>
    </>
  );
};

export default FormSummaryTable;
